import React from 'react';
import { IOSSwitch } from 'src/components/SwitchIos';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';

interface Props {
  title?: string,
  defaultChecked?: boolean,
  onChange?: (checked: boolean) => void,
}
export const MarketplaceSwitch: React.FC<Props> = ({ title, defaultChecked = true, onChange }) => {
  const mainStyles = mainUseStyles();
  return (
    <div className={mainStyles.switchWrapper}>
      {title && (
        <span>{ title }</span>
      ) }
      <div className="switchWrapperInner">
        <IOSSwitch
          defaultChecked={defaultChecked}
          onChange={(e: any) => onChange && onChange(e.target.checked)}
        />
      </div>
    </div>
  );
};
